import {
  getClientByBrick,
  getPhaseById,
  isPhaseEntry,
  isProjectEntry,
  phaseIdFromEntry,
  projectIdFromEntry,
} from '../../../utils/phases';

// Brique d'un client, cherchée dans toutes ses phases.
export function findBrick(client, briqueId) {
  for (const ph of client.phases || []) {
    const bb = (ph.briques || []).find((x) => x.id === briqueId);
    if (bb) return bb;
  }
  return null;
}

/* Client et libellé de brique d'une affectation. L'affectation peut viser une brique, une phase
   entière (« niveau phase (général) ») ou, ancien format, un projet entier. */
export function assignmentTarget(clients, briqueId) {
  if (isPhaseEntry(briqueId)) {
    const res = getPhaseById(clients, phaseIdFromEntry(briqueId));
    return { client: res?.client, brique: res ? `${res.phase.nom} (général)` : null };
  }
  if (isProjectEntry(briqueId))
    return {
      client: (clients || []).find((c) => c.id === projectIdFromEntry(briqueId)),
      brique: null,
    };
  const client = getClientByBrick(clients, briqueId)?.client;
  const bb = client ? findBrick(client, briqueId) : null;
  return { client, brique: bb ? bb.nom : null };
}
